(function () {
	'use strict';
	MxGridDateTimePickerCtrl.$inject = ['uiGridEditConstants', 'uiGridConstants', '$scope', '$timeout', '$element'];

	function MxGridDateTimePickerCtrl(uiGridEditConstants, uiGridConstants, $scope, $timeout, $element) {
		var vm = this;
		vm.$onInit = function () {
			var colDef = vm.col.colDef;
			vm.model = vm.row.entity[colDef.field];

			Object.defineProperty(vm, 'model', {
				get: function () {
					return vm.row.entity[colDef.field];
				},
				set: function (value) {
					vm.row.entity[colDef.field] = value;
					vm.col.grid.api.edit.raise.afterCellEdit(vm.row.entity, vm.col.colDef, value, value);
					//initTimer();
				},
			});

			vm.displayMode = formatToDisplayMode(colDef.item.Format);
			var dateMode = vm.displayMode === 'date';

			// function initTimer() {
			// 	return;
			// 	if(vm.hiding || dateMode){
			// 		return;
			// 	}
			// 	if(vm.timer){
			// 		$timeout.cancel(vm.timer);
			// 	}
			// 	vm.timer = $timeout(function () {
			// 		vm.hiding = true;
			// 		$scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
			// 	}, 4000);
			// }

			vm.onBlur = function () {
				if (dateMode) {
					$timeout(function () {
						$scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
					});
				}
			};

			$element.on('keydown', function (evt) {
				switch (evt.keyCode) {
					case uiGridConstants.keymap.ESC:
						evt.stopPropagation();
						$scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
						break;
				}

				return true;
			});

			$scope.$on('$destroy', function unbindEvents() {
				// unbind jquery events to prevent memory leaks
				$element.off();
			});

			//initTimer();
		};

		return vm;

		function formatToDisplayMode(format) {
			switch (format) {
				case 'medium':
				case 'short':
					return 'full';
				case 'fullDate':
				case 'longDate':
				case 'mediumDate':
				case 'shortDate':
					return 'date';
				case 'mediumTime':
				case 'shortTime':
					return 'time';
			}

			var dateParts =
				format.indexOf('y') !== -1 ||
				format.indexOf('M') !== -1 ||
				format.indexOf('L') !== -1 ||
				format.indexOf('d') !== -1 ||
				format.indexOf('E') !== -1 ||
				format.indexOf('w') !== -1 ||
				format.indexOf('G') !== -1;

			var timeParts =
				format.indexOf('H') !== -1 ||
				format.indexOf('h') !== -1 ||
				format.indexOf('m') !== -1 ||
				format.indexOf('s') !== -1 ||
				format.indexOf('a') !== -1 ||
				format.indexOf('Z') !== -1;

			if (dateParts && timeParts) {
				return 'full';
			}

			if (timeParts) {
				return 'time';
			}

			if (dateParts) {
				return 'date';
			}
		}
	}

	/**
	 * @ngdoc directive
	 * @name mx.components:mxGridDateTimePicker
	 * @module mx.components
	 * @restrict 'E'
	 * @description
	 * The mx-grid-date-time control is used in mx-grid for inline editing
	 *
	 * @usage <mx-grid-date-time data-col="col" data-row="row"></mx-grid-date-time>
	 */
	angular.module('mx.components').directive('mxGridDateTimePicker', [
		function mxGridDateTimePickerDirective() {
			return {
				scope: {},
				restrict: 'E',
				bindToController: {
					col: '=',
					row: '=',
				},
				controller: MxGridDateTimePickerCtrl,
				controllerAs: 'vm',
				template: [
					function () {
						return (
							'' +
							'<mx-date-time-picker ' +
							'ng-class="\'colt\' + vm.col.uid" ' +
							'data-on-blur="vm.onBlur" ' +
							'ng-model="vm.model" ' +
							'display-mode="{{vm.displayMode}}" data-iso-string="True" aria-invalid="false"' +
							'></mx-date-time-picker>' +
							''
						);
					},
				],
			};
		},
	]);
})();
